@use "../../sass/global/global" as *;

.ux-iws-price-box {
    @media only screen and (min-width: $desktop-l) {
        &--absolute {
            position: absolute;
            bottom: 0;
        }
    }

    @media only screen and (max-width: $desktop-l) {
        width: 100% !important;
    }

    &__container {
        display: inline-block;
        width: 100%;
        background: $color-blue-menu-bg;
        padding: $dim-30 $dim-15;

        @media only screen and (min-width: $tablet) {
            padding: $dim-30 10%;
        }

        @media only screen and (min-width: $desktop-l) {
            padding: $dim-30 $dim-15;
        }
    }

    &__button {
        display: flex;
        justify-content: flex-end;
    }

    &__button-group {
        @media only screen and (min-width: $tablet) {
            display: flex;
        }

        @media only screen and (min-width: $desktop-l) {
            display: inline-block;
        }
    }

    &__continue {
        display: inline-block;
        width: 100%;

        @media only screen and (min-width: $tablet) {
            display: flex;
            justify-content: space-evenly;
        }

        @media only screen and (min-width: $desktop-l) {
            display: inline-block;
        }
    }

    &__description {
        margin-top: 30px;
    }

    &__details {
        padding-bottom: $dim-15;
        border-bottom: 1px solid $color-gray-borders;

        .text-tiny {
            display: inline-block;
        }

        .text-tiny.u-uppercase {
            display: block;
        }
    }

    @media only screen and (min-width: $desktop-l) {
        &--fixed {
            position: fixed;
            top: 0;
        }
    }

    &__sum {
        display: flex;
        justify-content: space-between;

        font-family: "Frutiger-Bold";
        font-weight: bold;
        font-size: 1.3rem;

        @media only screen and (min-width: $tablet) {
            justify-content: space-evenly;
        }

        @media only screen and (min-width: $desktop-l) {
            justify-content: space-between;
        }

        &--amount {
            white-space: nowrap;
        }
    }

    p {
        margin: 0;
        color: $color-black;
    }
}
